import styled from 'react-emotion';

const P = styled('p')`
  font-size: 16px;
  font-family: arial, sans-serif;
  color: #666;
  margin-bottom: 2px;
`;

export default P;
